import { SizesOptions } from '@mui/material';

export const sizes: SizesOptions = {
  maxWidth: '80rem',
  appBarHeight: '3.5rem',
};
